(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-custom-text-button"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroSlider = (hero) => {
      if (!hero || hero.dataset.heroSliderInitialized === 'true') return;
      if (hero.dataset.heroSliderEnabled !== 'true') return;

      hero.dataset.heroSliderInitialized = 'true';

      const layers = [...hero.querySelectorAll('[data-hero-slide-layer]')];
      const blurs = [...hero.querySelectorAll('[data-hero-slide-blur]')];
      const dots = [...hero.querySelectorAll('[data-hero-slider-go]')];
      const autoplay = hero.dataset.heroSliderAutoplay === 'true';
      const delay = Math.max(2000, Number(hero.dataset.heroSliderDelay) || 5000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentSlide = 0;
      let timer = null;

      const setSlide = (index) => {
        currentSlide = index === 1 ? 1 : 0;

        layers.forEach((layer) => {
          const isActive = Number(layer.dataset.heroSlideLayer) === currentSlide;
          layer.classList.toggle('is-active', isActive);
          layer.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          layer.querySelectorAll('video').forEach((video) => {
            if (isActive) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        blurs.forEach((blur) => {
          const isActive = Number(blur.dataset.heroSlideBlur) === currentSlide;
          blur.classList.toggle('is-active', isActive);
        });

        dots.forEach((dot) => {
          const isActive = Number(dot.dataset.heroSliderGo) === currentSlide;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const stopAutoplay = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplay || reduceMotion) return;
        timer = window.setInterval(() => setSlide(currentSlide === 0 ? 1 : 0), delay);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setSlide(Number(dot.dataset.heroSliderGo));
          startAutoplay();
        });
      });


      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      setSlide(0);
      startAutoplay();
      hero._heroSliderStop = stopAutoplay;
    };

    const initAllHeroSliders = (root = document) => {
      if (root.matches && root.matches('[data-hero-slider-enabled="true"]')) initHeroSlider(root);
      root.querySelectorAll('[data-hero-slider-enabled="true"]').forEach(initHeroSlider);
    };

    initAllHeroSliders();

    document.addEventListener('shopify:section:load', (event) => {
      initAllHeroSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const hero = event.target.querySelector('[data-hero-slider-enabled="true"]');
      if (hero && typeof hero._heroSliderStop === 'function') hero._heroSliderStop();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
